// extracted by mini-css-extract-plugin
export default {"bondholdersBlock":"bounds_bondholdersBlock__x1woP","newsBounds":"bounds_newsBounds__Q+2Uz","filesBounds":"bounds_filesBounds__epyJz"};